import React from 'react'

import { MdArrowBack } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { useSiteFeatures } from '@hooks/siteFeatures'

import { DownstreamCard } from './Cards/Downstream'
import { MidstreamCard } from './Cards/Midstream'
import { Section } from '../../components/Section'

const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  min-height: 44px;
  padding: 8px 4px;
  color: ${({ theme }) => theme.colors.text};
  background: none;
  border: none;
  cursor: pointer;
`

export function JobSection() {
  const navigate = useNavigate()
  const { isMidstreamProcess } = useSiteFeatures()

  return (
    <Section
      title="Job Info"
      leftElement={
        <BackButton onClick={() => navigate(-1)}>
          <MdArrowBack size={24} />
        </BackButton>
      }
    >
      {isMidstreamProcess ? <MidstreamCard /> : <DownstreamCard />}
    </Section>
  )
}
